[{"display_name":"Singapore","location_slug":"singapore--singapore"}]